import React from 'react';
import { useAuth } from '../../context/AuthContext';
import EmployeeDashboard from './Dashboard';
import HRDashboard from './HRDashboard';

const DashboardWrapper = () => {
  const { user } = useAuth();

  // Show HR Dashboard for HR and Admin roles
  if (user && (user.role === 'hr' || user.role === 'admin')) {
    return <HRDashboard />;
  }

  // Show Employee Dashboard for regular employees
  return <EmployeeDashboard />;
};

export default DashboardWrapper;
